/** Whitelist: strip only trailing document extensions for catalogue/template UI (not persisted). */
export function stripTrailingDocumentExtension(displayName) {
  const raw = String(displayName || "").trim();
  if (!raw) return "";
  const dot = raw.lastIndexOf(".");
  if (dot <= 0) return raw;
  const tail = raw.slice(dot).toLowerCase();
  const allowed = [".doc", ".docx", ".pdf", ".ppt", ".pptx", ".xls", ".xlsx"];
  if (!allowed.includes(tail)) return raw;
  return raw.slice(0, dot);
}

/** Canonical basename from `fileName` or `templateId` (last path segment only). */
export function artefactFileBasename(row) {
  const source = row?.fileName ?? row?.templateId;
  const raw = String(source ?? "").trim();
  if (!raw) return "";
  const parts = raw.split(/[/\\]/);
  return parts[parts.length - 1] || raw;
}

/** Filename as shown in read-only Org Setup / onboarding tables — no trailing document extension. */
export function artefactFileNameUiDisplay(row) {
  return stripTrailingDocumentExtension(artefactFileBasename(row));
}
